"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiUrl = getApiUrl;
function getApiUrl(path) {
    return `${process.env.SERVICES_HOST}${path}`;
}
